// extracted by mini-css-extract-plugin
module.exports = {"modalSection":"changeScholarshipStateModal_modalSection__9z9eN","btns":"changeScholarshipStateModal_btns__j3FAj"};